<div
  [ngClass]="{ 's-drop': dndEnabled, 'no-drop': !dndEnabled }"
  [dndEnabled]="dndEnabled"
  appDnd
  (files)="onFileDropped($event)"
  (click)="onClick(file)"
>
  <input
    type="file"
    hidden
    id="file"
    [disabled]="isInputDisabled"
    (change)="fileBrowseHandler($event)"
    (click)="$event.target.value = null"
    [multiple]="multiple"
    [accept]="accept"
    #file
  />
  <div class="s-drop__content" (click)="stopEventPropagation($event)">
    <ng-content></ng-content>
  </div>

  <label *ngIf="chooseLabel" class="underscored">{{ chooseLabel }}</label>
</div>
